import { gql } from '@apollo/client';

export const QUERY_AB_TEST_PROB = gql`
    query probabilities($tests: [String!]) {
        probabilities(tests: $tests) {
            probability
            test
        }
    }
`;

export const UPDATE_USER_TEST_GROUP_MUTATION = gql`
    mutation updateUser($id: ID!, $testGroups: [String!]) {
        updateUser(id: $id, testGroups: $testGroups) {
            id
            testGroups
        }
    }
`;
